import React, { useEffect, useState } from 'react';
import { Box, Button, Card, CardActions, CardContent, CardMedia, Collapse, Grid, IconButton, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch } from 'react-redux';
import { deletePlayer } from '../../../../actions/players.js';
import avatar from'../../../../images/avatar-anonyme.png';
import { useNavigate, useLocation  } from 'react-router-dom';
import { deleteTeam } from '../../../../actions/teams.js';
import { confirmActionNotification } from '../../../../actions/notifications.js';
import { useNotifications } from '../../../../v2/notifications/NotificationManager.js';
import { Can } from '../../../../permissions/Can.js';
import { PERMISSIONS } from '../../../../permissions/permissionKeys.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport, faPenToSquare, faTrashCan, faUserFriends } from '@fortawesome/free-solid-svg-icons';
import DsasButton from '../../../components/DsasButton/DsasButton.js';
import { ExportButton } from '../../../components/Dialog/ExportButton.js';

const TeamCard = ({ team, removeTeamFromList, className, showExport=true, showPicture=true  }) => {
 
  const [expandedCompetitionHistory, setExpandedCompetitionHistory] = useState(false);
  const [expandedTeamInfo, setExpandedTeamInfo] = useState(false);
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const {addNotification} = useNotifications();

  const handleExpandClick = (type) => {
    if (type==='competition-history'){
      setExpandedCompetitionHistory(!expandedCompetitionHistory);
    }
    if (type==='team-info'){
      setExpandedTeamInfo(!expandedTeamInfo);
    }
    
  };

  const handleEditClick = () => {
    const currentURL = `${location.pathname}${location.search}`; // Inclut les paramètres
    navigate(`/sports/teams/create/${team._id}`, { state: { from: currentURL } });
  };

  const handleMultiEditClick = () => {
    const currentURL = `${location.pathname}${location.search}`; // Inclut les paramètres
    navigate(`/sports/teams/thirdparty/${team.thirdPartyId}/${team.thirdPartyEntityId}`, { state: { from: currentURL } });
  };

  const rawURL = `dsas-view/equipe/${team.name}_${team._id}`

  return (
    <Card className={className}>
          {/*SECTION HEADER*/}
          <Box className='padding-wrapper cardHeader'>
          <Typography className='cardTitle'>
              {team.name}
            </Typography>
          </Box> 
          <Box className='large-separator'></Box>

          {/*SECTION PHOTO + EXPORT*/}
                <Box className='padding-wrapper'>
                  <Grid container spacing={1.5}>
                  {showPicture && <Grid item xs={showExport ? 6 : 12} sm={showExport ? 6 : 12} md={showExport ? 6 : 12} className='userAvatarWrapper'>
                    {/* Image*/}
                    {team?.logoUrl && <CardMedia
                      className='userAvatar'
                      component="img"
                      image={team.logoUrl}
                      alt={`${team.name}`}
                    />}
                    {!team.logoUrl && 
                      <Box className='userAvatar'>
                        <FontAwesomeIcon icon={faUserFriends} />
                      </Box>
                    }
                    {/* </Box> */}
                    </Grid>}
                    {showExport &&
                    <Can permission={PERMISSIONS.SPORT_TEAM_HOME_BUTTON_PROFILE}>
                      <Grid item xs={showPicture ? 6 : 12} sm={showPicture ? 6 : 12} md={showPicture ? 6 : 12}>
                      <Box sx={{
                        display: 'grid', 
                      }}>

                        <Can permission={PERMISSIONS.SPORT_TEAM_HOME_BUTTON_EXPORT}>
                          <ExportButton targetUrl={rawURL}/>
                        </Can>
          
                      </Box>
                    </Grid>         
                    </Can> 
                    }
                  </Grid>
                </Box>


       {/*SECTION INFOS*/}
      {/*Expandable - Historique compétitions */}
      <CardContent sx={{ flex: '1 0 auto' }}>
        <Box className='display-grid'>
            <Box className='expandableMenu'>
              <Typography>Historique des compétitions</Typography>
              <IconButton
                sx={{ marginLeft: 'auto' }}
                onClick={() =>handleExpandClick('competition-history')}
                aria-expanded={expandedCompetitionHistory}
                aria-label="show more"
              >
                <ExpandMoreIcon />
              </IconButton>
            </Box>
          </Box>
          <Box className='large-separator medium-padding' sx={{width:'auto'}}></Box>
          <Collapse in={expandedCompetitionHistory} timeout="auto" unmountOnExit className='expandableInfos'>
            <CardContent className='large-content'>
              {/**
               * competitionsInfos:[{_id: "67922992100ceafa37e210fc", season: "2024/2025", name: "COMPET_TEST"}]
               */}
                {team.competitionsInfos && team.competitionsInfos.length ? (
                               team.competitionsInfos.map((competition, idx) => (
                                 <Box key={competition._id} sx={{ marginBottom: '1rem' }}>
                                   {/* Nom de la competition */}
                                   <Typography paragraph sx={{ textAlign: 'center', fontWeight: 'bold' }}> 
                                     {competition.name}
                                   </Typography>
                                    {/* Saison de la competition */}
                                    {/* Nom de la competition */}
                                   <Typography paragraph sx={{textAlign: 'center'}}> 
                                    Saison: {competition.season || 'Non spécifiée'}
                                   </Typography>
                                 </Box>
                               ))
                             ) : (
                               <Typography paragraph sx={{ textAlign: 'center' }}>Aucune compétition</Typography>
                             )}
            </CardContent>
          </Collapse>
      </CardContent>
      {expandedCompetitionHistory && <Box className='medium-padding large-separator'></Box>}

      {/*Expandable - Infos joueur*/}
      <CardContent sx={{ flex: '1 0 auto' }}>
        <Box className='display-grid'>
          <Box className='expandableMenu'>
            <Typography>Info équipe</Typography>
              <IconButton
                sx={{ marginLeft: 'auto' }}
                onClick={() => handleExpandClick('team-info')}
                aria-expanded={expandedTeamInfo}
                aria-label="show more"
              >
                <ExpandMoreIcon />
              </IconButton>
          </Box>
        </Box>
        <Box className='large-separator medium-padding' sx={{width:'auto'}}></Box>
        <Collapse in={expandedTeamInfo} timeout="auto" unmountOnExit className='expandableInfos'>
            <CardContent>
              <Typography paragraph>Stade: {team.stadium || 'Non spécifié'}</Typography>
              <Typography paragraph>Capacité: {team.size || 'Non spécifiée'}</Typography>
              <Typography paragraph>Pays: {team.country || 'Non spécifié'}</Typography>
              <Typography paragraph>Année de création: {team.teamCreation || 'Non spécifiée'}</Typography>
              <Typography paragraph>Site web : {team.website || 'Non spécifié'}</Typography>
              <Typography paragraph>Président : {team.president || 'Non spécifié'}</Typography>
              <Typography paragraph>Coach(s) : {team.coach || 'Non spécifié(s)'}</Typography>
            </CardContent>
        </Collapse>
      </CardContent>

      {/* <Box className='medium-padding'></Box> */}

      {/* Card Actions */}
      <Box className='large-separator'></Box>
      <Box className='cardActions'>
            <>
              {/*TEAM EDITION BUTTON*/}
              <Box className='centered-column-wrapper'>
                <Can permission={PERMISSIONS.SPORT_TEAM_HOME_BUTTON_EDIT}>
                  <DsasButton label='Éditer' icon={faPenToSquare} onClick={handleEditClick} variant = 'secondary' />
                </Can>

                {/*TEAM MULTI-EDIT BUTTON*/}
                {(team.thirdPartyId && team.thirdPartyEntityId) && 
                <Can permission={PERMISSIONS.SPORT_TEAM_HOME_BUTTON_MULTIEDIT}>
                  <DsasButton label='Multi-édition' icon={faPenToSquare} onClick={handleMultiEditClick} variant = 'secondary' />
                </Can>}
              </Box>
      
              <Box className='xl-vertical-separator'></Box>
              
              {/*TEAM DELETION BUTTON*/}
              <Box className='centered-column-wrapper'>
                <Can permission={PERMISSIONS.SPORT_TEAM_HOME_BUTTON_DELETE}>
                  <DsasButton label='Supprimer' icon={faTrashCan} onClick={() => { dispatch(confirmActionNotification("Êtes-vous sûr de vouloir supprimer l'équipe ?", () => {
                  dispatch(deleteTeam(team._id, (id) => {removeTeamFromList(id) ; addNotification({
                    title : "Suppression", 
                    type : "success", 
                    description : "L'équipe "+ team.name+" a été supprimée."
                    })}))
                  })) }} variant = 'secondary' />
                </Can>
              </Box>
            </>   
      </Box>
    </Card>
  );
};

export default TeamCard;
